<template>
  <v-container class="shopStartPage">
    <div ref="lastArticlesHeader" class="lastArticlesContainer">
    <v-toolbar class="categoriesHeader" elevation="0"
    >
      <v-toolbar-title class="pageTitle">
        Initiales Passwort
      </v-toolbar-title>
    </v-toolbar>
    <v-divider class="headerDivider"/>

    <v-card class="articleCard initialPwCard">
      <v-card-text>
        Hallo {{ firstName }},
          <br/>
        du hast dich zum ersten Mal angemeldet.
          <br/>
        Um dich zukünftig anmelden zu können, musst du ein Passwort angeben.
          <br/>
        Dies kannst du nun unten tun.
      </v-card-text>

      <v-snackbar class="mismatchedPwBar" top v-model="passwordMismatch">
        <Span>Deine eingegebenen Passwörter stimmen nicht überein.</Span>
      </v-snackbar>

      <v-form class="shopStartPage">
        <v-container>
          <v-row>
              <v-col cols="12">
                <v-text-field
                    rounded
                    v-model="password"
                    type="password"
                    outlined
                    dense
                    placeholder="Neues Passwort"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                    rounded
                    v-model="passwordRepeat"
                    type="password"
                    outlined
                    dense
                    placeholder="Passwort wiederholen"
                ></v-text-field>

                  <v-btn class="setPwBtn"
                         @click="savePassword"
                  >
                  <span>
                    Passwort sichern
                  </span>
                  </v-btn>
              </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card>
    </div>
  </v-container>
</template>

<script>
import {mapActions} from 'vuex';

export default {
  name: "setPassword",
  data: () => {
    return {
      password: '',
      passwordRepeat: '',
      firstName: '',

      passwordMismatch: false,
    }
  },

  methods: {
    ...mapActions({
      setHeaderVisibility: 'setHeaderVisibility',
      setPassword: 'setPassword',
      logout: 'logout'
    }),

    savePassword() {

      if(this.password === this.passwordRepeat) {
        const passwords = {
          password: this.password,
          passwordRepeat: this.passwordRepeat
        }
        this.setPassword(passwords)
      }
      else {
        this.passwordMismatch = true
      }
    }
  },

  mounted() {
    this.firstName = JSON.parse(localStorage.getItem('user'))['firstName']
    this.setHeaderVisibility(false)
  }
}
</script>

<style>

.setPwBtn {
  right: calc(4% + 15px);
  position: absolute;
  background-color: var(--igros-red)!important;
}

.setPwBtn.theme--light.v-btn {
  min-height: 20px;
  bottom: -22px;
}

.initialPwCard {
  display: flex;
  flex-direction: column;
  overflow: visible!important;
  padding: 15px;
  margin-top: 15px;
}

.initialPwCard .v-card__text {
  text-align: left;
}

</style>